import { useMemo } from 'react';
import { useLoaderData } from 'react-router-dom';

import type { VideosContext } from 'src/routes/video-landing-page/shared';

export interface PosthogAttributionData {
  store: string;
  video: string;
  email: string | null;
  phone: string | null;
  firstName: string | null;
  endCustomerId: string | null;
}

export function usePosthogAttributionDataFromLoader(): PosthogAttributionData {
  const { object, storeInfo, customerFirstName, email, phone, endCustomerId } =
    useLoaderData() as VideosContext;
  return useMemo(
    () => ({
      store: storeInfo.key_name,
      video: object.unique_id,
      email: email,
      phone: phone,
      firstName: customerFirstName,
      endCustomerId: endCustomerId,
    }),
    [customerFirstName, email, endCustomerId, object.unique_id, phone, storeInfo.key_name],
  );
}
